import { createSelector } from 'reselect';
import { reduce } from 'es-toolkit/compat';

import {
  CONDENSED_SECTION_LABEL,
  TABLELESS_SECTION_LABEL,
} from 'constants/TableBasedInventoryConstants';
import { NormalDetailedSquare, NormalSquareSubtypes } from 'types/tableBasedInventory';
import {
  TableIdToSection,
  activeAndArchivedCalendarFloorPlanTableIdToSectionSelector,
} from 'selectors/routes/calendar/calendarFloorplanSelector';
import allCalendarSquaresSelector from 'selectors/routes/calendar/detailedCalendarSquaresSelector';

export interface SectionStatsMap {
  [sectionName: string]: number;
}

function computeCoverStatsBySection(
  tableIdToSection: TableIdToSection,
  allSquares: NormalDetailedSquare[]
): SectionStatsMap {
  return reduce(
    allSquares,
    (sectionStatsMap: SectionStatsMap, square) => {
      if (square.subType !== NormalSquareSubtypes.BOOKED) {
        return sectionStatsMap;
      }
      if (square.isDuplicate) {
        return sectionStatsMap;
      }
      const ticketCount = square.purchase.ticketCount;
      if (square.tableId && tableIdToSection[square.tableId]) {
        const sectionLabel = tableIdToSection[square.tableId];
        if (sectionStatsMap[sectionLabel]) {
          sectionStatsMap[sectionLabel] = sectionStatsMap[sectionLabel] + ticketCount;
        } else {
          sectionStatsMap[sectionLabel] = ticketCount;
        }
      } else {
        sectionStatsMap[TABLELESS_SECTION_LABEL] =
          sectionStatsMap[TABLELESS_SECTION_LABEL] + ticketCount;
      }
      // all inventory for condensed view
      sectionStatsMap[CONDENSED_SECTION_LABEL] =
        sectionStatsMap[CONDENSED_SECTION_LABEL] + ticketCount;
      return sectionStatsMap;
    },
    { [TABLELESS_SECTION_LABEL]: 0, [CONDENSED_SECTION_LABEL]: 0 }
  );
}

export const coverStatsBySectionSelector = createSelector(
  activeAndArchivedCalendarFloorPlanTableIdToSectionSelector,
  allCalendarSquaresSelector,
  computeCoverStatsBySection
);
